import React, { useState, useEffect } from "react";
import "../styles/navbar.css"; // make sure path is correct

export default function Navbar() {
  const [open, setOpen] = useState(false);

  // close on ESC
  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") setOpen(false);
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <>
      <header className="site-header">
        <div className="nav-inner">
          <div className="brand">
            <a href="/">
              <img
                className="brand-logo"
                src={"/images/logo.png"}
                alt="PV"
              />
            </a>
            
            <h1><a href="/">PracVerse</a></h1>
          </div>

          {/* centered nav items (desktop) */}
          <nav className="primary-nav" aria-label="Primary">
            <a href="/" className="nav-link">Home</a>
            <a href="/courses" className="nav-link">Courses</a>
            <a href="/events" className="nav-link">Events</a>
            <a href="/partnerships" className="nav-link">Partnerships</a>
            <a href="/testimonials" className="nav-link">Testimonials</a>
            <a href="/about" className="nav-link">About</a>
            <a href="/contact" className="nav-link">Contact</a>
          </nav>

          {/* right side CTA (desktop) + mobile hamburger */}
          <div className="nav-right">
            <a href="/contact" className="btn-cta">Get Started</a>

            {/* hamburger shows on mobile */}
            <button
              className={`hamburger ${open ? "is-open" : ""}`}
              aria-label={open ? "Close menu" : "Open menu"}
              aria-expanded={open}
              onClick={() => setOpen(v => !v)}
            >
              <span className="hamburger-lines" />
            </button>
          </div>
        </div>
      </header>

      {/* overlay + slideout panel for mobile */}
      <div className={`mobile-overlay ${open ? "visible" : ""}`} onClick={() => setOpen(false)} />

      <aside className={`mobile-panel ${open ? "open" : ""}`} aria-hidden={!open}>
        <div className="mobile-panel-header">
          <a href="/" className="mobile-brand">
            <img
              src={"/images/logo.png"}
              alt="PV"
              className="mobile-logo"
            />
          </a>
          <button className="mobile-close" aria-label="Close menu" onClick={() => setOpen(false)}>✕</button>
        </div>

        <nav className="mobile-nav" aria-label="Mobile Primary">
          <a href="/" className="mobile-nav-link" onClick={() => setOpen(false)}>Home</a>
          <a href="/courses" className="mobile-nav-link" onClick={() => setOpen(false)}>Courses</a>
          <a href="/events" className="mobile-nav-link" onClick={() => setOpen(false)}>Events</a>
          <a href="/partnerships" className="mobile-nav-link" onClick={() => setOpen(false)}>Partnerships</a>
          <a href="/testimonials" className="mobile-nav-link" onClick={() => setOpen(false)}>Testimonials</a>
          <a href="/about" className="mobile-nav-link" onClick={() => setOpen(false)}>About</a>
          <a href="/contact" className="mobile-nav-link" onClick={() => setOpen(false)}>Contact</a>

          <div className="mobile-cta-wrap">
            <a href="/get-started" className="btn-cta mobile-cta" onClick={() => setOpen(false)}>Get Started</a>
          </div>
        </nav>
      </aside>
    </>
  );
}
